import { Component, Input } from '@angular/core';
import { User } from '../../../../../module/user/types';
import { DialogService } from '../../../../../services/dialog.service';
import { BehaviorSubject } from 'rxjs';
import { ChangePasswordDialogComponent } from '../../../../../module/user/dialog/change-password/change-password-dialog.component';

@Component({
  selector: 'user-change-password-button',
  template: `
    <fieldmagic-primary-button
      klass="p-0"
      purpose="icon"
      [icon]="[{
        icon: 'fingerprint',
        size: 'list-icon'
      }]"
      tooltip="Change Password"
      (click)="onChangePassword()"
    ></fieldmagic-primary-button>
  `,
  providers: [
    DialogService,
  ],
})
export class ChangeUserPasswordButtonComponent {
  @Input() user: User;

  readonly processing$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly _dialog: DialogService,
  ) {}

  onChangePassword(): void {
    this.processing$.next(true);

    this._dialog.show({
      component: ChangePasswordDialogComponent,
      data: {
        user: this.user,
      },
      afterClosing: (_) => this.processing$.next(false),
    });
  }
}